import { render, staticRenderFns } from "./abilityStratification.vue?vue&type=template&id=8b1cdd62&scoped=true"
import script from "./abilityStratification.vue?vue&type=script&lang=js"
export * from "./abilityStratification.vue?vue&type=script&lang=js"
import style0 from "./abilityStratification.vue?vue&type=style&index=0&id=8b1cdd62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1cdd62",
  null
  
)

export default component.exports